import React from 'react'
import { useForm, Link } from '@inertiajs/react'
import { TextField, Button, Box, Typography, Stack } from '@mui/material'
import AuthLayout from '@/components/layouts/AuthLayout'
import { SPACING } from '@/theme'

interface Props {
  minimumPasswordLength?: number
}

export default function Register({ minimumPasswordLength = 6 }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/users')
  }

  return (
    <AuthLayout title="Create your account">
      <Stack component="form" onSubmit={handleSubmit} spacing={SPACING.gap.md}>
        <TextField
          label="Email address"
          type="email"
          fullWidth
          value={data.email}
          onChange={(e) => setData('email', e.target.value)}
          error={!!errors.email}
          helperText={errors.email}
          autoFocus
          autoComplete="email"
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          value={data.password}
          onChange={(e) => setData('password', e.target.value)}
          error={!!errors.password}
          helperText={errors.password || `${minimumPasswordLength} characters minimum`}
          autoComplete="new-password"
        />
        <TextField
          label="Confirm password"
          type="password"
          fullWidth
          value={data.password_confirmation}
          onChange={(e) => setData('password_confirmation', e.target.value)}
          error={!!errors.password_confirmation}
          helperText={errors.password_confirmation}
          autoComplete="new-password"
        />
        <Button type="submit" variant="contained" fullWidth size="large" disabled={processing}>
          Sign up
        </Button>
        <Typography variant="body2" align="center">
          Already have an account? <Link href="/users/sign_in">Sign in</Link>
        </Typography>
      </Stack>
    </AuthLayout>
  )
}
